import React, { useEffect } from 'react';
import Datas from '../data/faq-event/admission_procedures.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col,Button } from 'react-bootstrap';
import { Styles } from "./styles/faqEvent.js";

function Admindetails() {
    useEffect(() => {
        const accordionButton = document.querySelectorAll(".accordion-button");
        accordionButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "accordion-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "accordion-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    });

    return (
        <Styles>
            {/* Faq & Event */}
            <section className="event-faq-area">
                <Container>
                    <Row>
                        <Col md="6">
                            <div className="faq-area">
                                <div className="sec-title">
                                    <h4>Admission Procedure </h4>
                                </div>
                                <div className="faq-box">
                                    {
                                        Datas.admissionsList.map((faqData, i) => (
                                            <div className="faq-item" key={i}>
                                                <button className="accordion-button active">
                                                    <div className="accordion-icon"><i className="las la-plus"></i></div>
                                                    <p>{faqData.adminssionTitle}</p>
                                                </button>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="faq-area">
                                <div className="sec-title">
                                    <h4>Combinations Offered</h4>
                                </div>
                                <div className="faq-box">
                                    {
                                        Datas.combinationsList.map((faqData, i) => (
                                            <div className="faq-item" key={i}>
                                                <button className="accordion-button active">
                                                    <div className="accordion-icon"><i className="las la-plus"></i></div>
                                                    <p>{faqData.combinationTitle}</p>
                                                </button>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <div className="faq-area">
                                <div className="sec-title">
                                    <h4>Lateral admissions from Class 2 to Class 8</h4>
                                </div>
                                <div className="faq-box">
                                    <div className="faq-item" >
                                        <p>Lateral admissions are based on written tests and personal interviews and also based on availability of seats.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="9">
                            <div className="faq-area">
                                <div className="sec-title">
                                    <h4>PRE-UNIVERSITY ADMISSIONS</h4>
                                </div>
                                <div className="faq-box">
                                    <div className="faq-item" >
                                        <p>Merit based provisional admission will be made to First PU as soon as X standard Board Examination results are announced when the name is registered along with internet marks list.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md="3">
                        <Button   className="admission"><Link to={process.env.PUBLIC_URL + "/contact"} className="menu_link"><blink>Admissions Open</blink></Link></Button>
                        </Col>

                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default Admindetails
